import React, { cloneElement, isValidElement, ReactNode } from 'react';
import styles from './styles.module.css';
import { setState } from '@/commonTypes';

export default function SearchCategorySection({
  list,
  activeMenu,
  setActiveMenu,
}: {
  list?: { id: string; title: string; icon?: ReactNode; count?: number | string }[];
  activeMenu?: string;
  setActiveMenu?: setState<string>;
}) {
  return (
    <div className={`${styles.wrapper}`}>
      {list?.map((item, index) => (
        <div
          key={index}
          className={`${styles.item} ${activeMenu == item?.id && styles.active}`}
          onClick={() => {
            setActiveMenu && setActiveMenu(item?.id);
          }}
        >
          {isValidElement(item?.icon)
            ? cloneElement(item?.icon, {
                fill: activeMenu == item?.id ? 'var(--text-color)' : 'var(--text-mut)',
                width: `${'16px'}`,
                height: `${'16px'}`,
              })
            : item?.icon}
          <span className={`${styles.title}`}>{item?.title}</span>
          <span className={`${styles.count}`}>{item?.count}</span>
        </div>
      ))}
    </div>
  );
}
